import React from 'react';
import Icon from '../AppIcon';
import { normalizeRequestStatus } from './requestBuilderUtils';

const STATUS_CONFIG = {
  pending: { label: 'Pending', icon: 'Clock', className: 'border-warning/30 bg-warning/10 text-warning' },
  inprogress: { label: 'In Progress', icon: 'Loader', className: 'border-primary/30 bg-primary/10 text-primary' },
  completed: { label: 'Completed', icon: 'CheckCircle', className: 'border-success/30 bg-success/10 text-success' },
  rejected: { label: 'Rejected', icon: 'XCircle', className: 'border-destructive/30 bg-destructive/10 text-destructive' },
  cancelled: { label: 'Cancelled', icon: 'Ban', className: 'border-destructive/30 bg-destructive/10 text-destructive' },
};

export const getRequestStatusConfig = (status) => (
  STATUS_CONFIG[normalizeRequestStatus(status)] || {
    label: status || 'Unknown',
    icon: 'CircleHelp',
    className: 'border-border bg-muted text-muted-foreground',
  }
);

const RequestStatusBadge = ({ status, className = '', showIcon = true, compact = false }) => {
  const config = getRequestStatusConfig(status);
  return (
    <span className={`inline-flex items-center rounded-full border font-caption ${compact ? 'px-2 py-0.5 text-[10px]' : 'px-3 py-1 text-xs'} ${showIcon ? 'gap-1.5 font-semibold' : 'font-medium'} ${config.className} ${className}`}>
      {showIcon && (
        <Icon name={config.icon} size={14} className={normalizeRequestStatus(status) === 'inprogress' ? 'animate-spin' : ''} />
      )}
      {config.label}
    </span>
  );
};

export default RequestStatusBadge;
